import * as React from 'react'
import BoxBody from '../helper/boxBody'

class Box extends React.Component<{ className?: string; onClick?: () => void; children?: React.ReactNode }> {
    public render = () => (
        <div
            className={[this.props.className, 'box box-default'].join(' ')}
            onClick={this.props.onClick}
            style={this.props.onClick ? { cursor: 'pointer' } : undefined}
        >
            {this.props.children}
        </div>
    )
}

class BoxHeader extends React.Component<{ className?: string; children?: React.ReactNode; flexbox?: boolean }> {
    public render = () => (
        <div className={[this.props.flexbox ? 'box-header box-header-flex' : 'box-header', this.props.className].join(' ')}>
            {this.props.children}
        </div>
    )
}

class BoxFooter extends React.Component<{ className?: string; children?: React.ReactNode }> {
    public render = () => <div className={['box-footer', this.props.className].join(' ')}>{this.props.children}</div>
}

class BoxTitle extends React.Component<{ className?: string; muted?: boolean; children?: React.ReactNode }> {
    public render = () => (
        <h3 className={[this.props.className, 'box-title', this.props.muted ? 'text-muted' : undefined].join(' ')}>
            {this.props.children}
        </h3>
    )
}

export { Box, BoxHeader, BoxBody, BoxTitle, BoxFooter }
